import React, { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { ReOrderDotsVertical20Regular } from '@fluentui/react-icons';
import { RankingQuestion as RankingQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#242424',
    marginBottom: '12px',
  },
  optionsArea: {
    paddingLeft: '20px',
    paddingRight: '10px',
    width: 'calc(100% - 30px)',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  optionRow: {
    display: 'flex',
    gap: '0',
    alignItems: 'center',
    height: '32px',
    backgroundColor: 'white',
    border: '1px solid #d1d1d1',
    borderRadius: '4px',
    paddingLeft: '10px',
  },
  dragHandle: {
    fontSize: '20px',
    color: '#616161',
    cursor: 'grab',
    display: 'none',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  optionLabel: {
    flex: 1,
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    color: '#242424',
    lineHeight: '20px',
    paddingRight: '10px',
  },
});

interface RankingQuestionViewProps {
  question: RankingQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const RankingQuestionView: React.FC<RankingQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();
  const [rankedOptions] = useState(question.options);

  return (
    <div className={styles.container} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} data-question-view>
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      <div className={styles.optionsArea}>
        {rankedOptions.map((option, index) => (
          <div key={typeof option === 'string' ? index : option.id} className={styles.optionRow}>
            <ReOrderDotsVertical20Regular className={styles.dragHandle} />
            <div className={styles.optionLabel}>{typeof option === 'string' ? option : option.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
